import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { ClassNames } from '@emotion/core';
import { useBlurOnMouseDown } from '../utils/use-blur-on-mouse-down';
import BaseItem from './base-item';
import { customItemCSS } from './styles';

var preventEvent = function preventEvent(e) {
  e.preventDefault();
}; // Dirty hack to get generics working with forward ref [1/2]


var CustomItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var Component = _ref.component,
      _ref$cssFn = _ref.cssFn,
      cssFn = _ref$cssFn === void 0 ? function (currentStyles) {
    return currentStyles;
  } : _ref$cssFn,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      onClick = _ref.onClick,
      testId = _ref.testId,
      children = _ref.children,
      description = _ref.description,
      iconAfter = _ref.iconAfter,
      iconBefore = _ref.iconBefore,
      overrides = _ref.overrides,
      onMouseDown = _ref.onMouseDown,
      rest = _objectWithoutProperties(_ref, ["component", "cssFn", "isDisabled", "isSelected", "onClick", "testId", "children", "description", "iconAfter", "iconBefore", "overrides", "onMouseDown"]);

  var onMouseDownHandler = useBlurOnMouseDown(onMouseDown);

  if (!Component) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ClassNames, null, function (_ref2) {
    var css = _ref2.css;
    return /*#__PURE__*/React.createElement(Component, _extends({
      ref: ref,
      "data-testid": testId,
      onDragStart: preventEvent,
      draggable: false,
      className: css(cssFn(customItemCSS(isDisabled, isSelected), {
        isDisabled: isDisabled,
        isSelected: isSelected
      })),
      onMouseDown: onMouseDownHandler,
      onClick: isDisabled ? undefined : onClick,
      tabIndex: isDisabled ? -1 : undefined,
      disabled: isDisabled
    }, rest), /*#__PURE__*/React.createElement(BaseItem, {
      overrides: overrides,
      children: children,
      description: description,
      iconAfter: iconAfter,
      iconBefore: iconBefore
    }));
  });
} // Dirty hack to get generics working with forward ref [2/2]
);
export default CustomItem;